<!--
 * @Author: your name
 * @Date: 2021-04-14 10:17:21
 * @LastEditTime: 2021-04-16 09:31:47
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /ecmp5-client-web/src/views/user/receipt/IncludeList.vue
-->

<template>
  <Nav-bar :has_back="true" :has_right="false" title="所含内容"></Nav-bar>
  <div class="top-margin"></div>
  <div class="container">
    <div class="item-v" v-for="item in list" :key="item">
      <div class="t-f14-c99"> {{$filters.timeFormate(item.start_charging_at)}}</div>
      <span class="t-f14-c1a font-bold">{{item.charge_station.name}}</span>
      <div class="t-f14-c66 m-t-5">充电量{{item.total_power}} 度</div>

      <span class="t-f16-cf19321 r-t">¥{{item.amount}}</span>
      <span class="t-f12-c99 r-b">{{item.service_provider.name}}</span>
    </div>
   
  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import { useStore } from "vuex";
import { ref } from "vue";
let storeContext;
export default {
  components: {
    NavBar,
  },
  setup() {
    storeContext = useStore();
    const list = ref(storeContext.state.invoicesData.invoicesList);
    return { list };
  },
};
</script>
<style scoped>
.r-t {
  position: absolute;
  right: 15px;
  top: 15px;
}
.r-b {
  position: absolute;
  right: 15px;
  bottom: 15px;
}
.status-icon {
  width: 44px;
  height: 44px;
  position: absolute;
  right: 15px;
  bottom: 15px;
}
.item-v {
  background: #fff;
  margin-top: 10px;
  padding: 15px;
  margin: 10px;
  position: relative;
}
.company_icon {
  width: 20px;
  height: 20px;
}
</style>